











/**
 * FUPOF-193 — the trigger for pasting a Shade Designer configuration code,
 * dropped into the umbrella menu headline, the cart headline and the sidebar.
 * The wording and the link (rather than button) treatment mirror Shade
 * Designer's own affordance so reps who use both applications recognise it.
 *
 * This is only the trigger: the modal itself lives at the app root (App.vue)
 * and is opened over the EventBus, the same way CartModal is. It deliberately
 * does NOT render the modal as its own child — the sidebar's panel carries a
 * `transform`, which makes it the containing block for any `position: fixed`
 * descendant. A modal mounted inside it is measured against the 270px panel
 * instead of the viewport, and slides off-screen with the menu when it closes.
 */
import { Component, Prop, Vue } from "vue-property-decorator";
import { EventBus } from "@/event-bus";

@Component
export default class ConfigCodeButton extends Vue {
  /** "nav" renders as a sidebar item; anything else as an inline text link. */
  @Prop({ default: "button" }) variant!: "button" | "nav";

  protected open(): void {
    // The sidebar listens for this to close itself before the modal appears.
    this.$emit("open");
    EventBus.$emit("openConfigCodeModal");
  }
}
